import { BrowserCacheLocation } from '@azure/msal-browser';
import { Providers } from '@microsoft/mgt-element';
import { Msal2Provider } from '@microsoft/mgt-msal2-provider';
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

console.log('ENV:::', process.env);

Providers.globalProvider = new Msal2Provider({
    clientId: process.env.REACT_APP_CLIENT_ID || "",
    authority: process.env.REACT_APP_AUTHORITY || "",
    scopes: ['user.read', 'user.readbasic.all']
});

export const Config = {
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge. Remove this line to use Angular Universal
    }
}

export const ServiceEndpoints = {
    caseAPIEndpoint: {
        //endpoint: "https://localhost:44351/api/",
        // endpoint: process.env.NODE_ENV.trim() === 'dev' ? "https://localhost:7281/api/" : process.env.REACT_APP_LOCAL_API_URL,
        endpoint: process.env.REACT_APP_API_URL,
        scopes: process.env.REACT_APP_SCOPE_ID || ""
    },
    apiGraph: {
        endpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
        scopes: "User.ReadBasic.All"
    }
}

export const CACHE_TTL_IN_MS = 60 * 60 * 1000; // 1 hour in milliseconds

// Feature Toggle Configuration
export const FeatureFlags = {
    enableProductSearch: true // Controls enhanced search features - Enter key search functionality
};